const Routes = [];

/*** PUBLIC RULES */

Routes.push({
    path: "/initialize",
    meta: {
        public: true
    },
    name: "initialize",
    component: () => import("@/views/Initialize.vue")
});

Routes.push({
    path: "/login",
    meta: {
        public: true
    },
    name: "login",
    component: () => import("@/views/Login.vue")
});

/*** PRIVATE RULES */
Routes.push({
    path: "/",
    //redirect: "/m-configs",
    meta: {},
    name: "home",
    component: () => import("@/views/Home.vue")
});

/*** SYSTEM RULES */
Routes.push(
    {
        path: "*",
        meta: {
            public: true
        },
        redirect: {
            path: "/404"
        }
    },
    {
        path: "/404",
        meta: {
            public: true
        },
        name: "404",
        component: () => import("@/views/system/404.vue")
    },
    {
        path: "/403",
        meta: {
            public: true
        },
        name: "403",
        component: () => import("@/views/system/403.vue")
    },
    {
        path: "/500",
        meta: {
            public: true
        },
        name: "500",
        component: () => import("@/views/system/500.vue")
    }
);

export default Routes;